<template>
  <div>
    <search-bar :items="[
      { key: 'type', type: 'select', state: 'transaction_date_type', noAll: true, defaultValue: '1' },
      { key: 'create_time', type: 'daterange', placeholder: 'Date', times: dates, defaultValue: defaultDateRange },
      { key: 'sales_id', label: 'Sales', type: 'select', state: 'sales', option_value: 'id', option_label: 'realname', width: 120 }
    ]" @search="search"/>
    
    <div class="card">
      <el-pagination @size-change="pageSizeChange" @current-change="pageChange" :current-page="currentPage" :page-sizes="[20, 50, 100, 500]" :page-size="pageSize" layout="total, sizes, pager" :total="total" style="text-align:right;"></el-pagination>
      <table class="normal-table">
        <tr>
          <th>#</th>
          <th style="width:340px;">Company Name</th>
          <th>Company ID</th>
          <th>Country</th>
          <th>Sales</th>
          <th>Issue Date</th>
          <th>Pay Date</th>
          <th>Delivery</th>
          <th>Amount(USD)</th>
        </tr>
        <tr v-for="(item, index) in list" :key="item.id">
          <td>{{ index + 1 }}</td>
          <td><a :href="'/customer/company/' + item.id" target="_blank">{{ item.name }}</a></td>
          <td>{{ item.id }}</td>
          <td>{{ item.country }}</td>
          <td>{{ item.sales_name }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </table>
      <no-data :loading="loading" :list="list"></no-data>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ListFunc from '@/mixins/ListFunc'
import NoData from '@/components/NoData'
export default {
  mixins: [ListFunc],
  components: {
    NoData
  },
  data () {
    return {
      sqlcode: 'vendor_transaction',
      pageSize: 100,
      defaultDateRange: [moment().startOf('month'), moment().endOf('day')],
      dates: [
        { text: 'All', value: [] },
        { text: 'This Month', value: [moment().startOf('month'), moment().endOf('day')] },
        { text: 'Last Month', value: [moment().subtract(1, 'months').startOf('month'), moment().subtract(1, 'months').endOf('month')] },
        { text: '3 Month', value: [moment().subtract(3, 'months'), moment().endOf('day')] },
        { text: '6 Month', value: [moment().subtract(6, 'months'), moment().endOf('day')] },
        { text: 'This Year', value: [moment().startOf('year'), moment().endOf('day')] },
        { text: 'Last Year', value: [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')] }
      ]
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  }
}
</script>

